(function () {
  // Keeps the cart disclosure hover tooltip within the viewport.
  // On hover we measure the tooltip and set a `--cart-disclosure-tooltip-shift`
  // custom property that nudges it back into view;
  // the arrow is counter-shifted in CSS so it keeps pointing at the icon.
  const VIEWPORT_MARGIN = 16;

  function positionTooltip(button) {
    const tooltip = button.querySelector('.cart-item__disclosure-tooltip');
    if (!tooltip) return;

    // Reset before measuring so we read the natural, centered position.
    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', '0px');

    const rect = tooltip.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;

    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }

    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', `${Math.round(shift)}px`);
  }

  function onPointerOver(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (!button || button.dataset.tooltipPositioned === 'true') return;

    button.dataset.tooltipPositioned = 'true';
    positionTooltip(button);
  }

  function onPointerOut(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (button && !button.contains(event.relatedTarget)) {
      delete button.dataset.tooltipPositioned;
    }
  }

  document.addEventListener('pointerover', onPointerOver);
  document.addEventListener('pointerout', onPointerOut);
})();

(function () {
  // FMH 18.10.2026: one rating look on cards and product pages — the same SVG stars (honey, last star filled by
  // the exact fraction), the real average as a number ("4.8") and the count in brackets ("(78)", no word "reviews").
  // Cards: Dawn rounds stars to whole/half, so every 4.7-4.97 looked like 5.0; value from the card's .rating-text.
  // Product page: Judge.me preview badge, value from its data-average-rating; Judge.me's own stars are hidden.
  // Offer 1003 (little-duck-treat-spinner-offer, 8051362463786) is skipped until Pasha's ad test ends (20.10).
  // Styles: assets/fmh-note.css.
  var SKIP_PRODUCT_IDS = ['8051362463786'];
  var PATH = 'M12 2.5l2.94 5.96 6.56.95-4.75 4.63 1.12 6.54L12 17.5l-5.87 3.08 1.12-6.54L2.5 9.41l6.56-.95z';
  function row() {
    var svg = '';
    for (var i = 0; i < 5; i++) svg += '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + PATH + '"/></svg>';
    return svg;
  }
  function stars(value) {
    var el = document.createElement('span');
    el.className = 'fmh-stars';
    el.setAttribute('aria-hidden', 'true');
    var full = Math.floor(value);
    var part = value - full;
    // each star is 1em wide with a 0.2em gap: fill width in em
    var width = full * 1.2 + part;
    el.innerHTML = '<span class="fmh-stars__base">' + row() + '</span><span class="fmh-stars__fill" style="width:' + width.toFixed(3) + 'em">' + row() + '</span>';
    return el;
  }
  function fmhRatings() {
    document.querySelectorAll('.card-information .rating-text span:not([data-fmh])').forEach(function (span) {
      var value = parseFloat(span.textContent);
      span.dataset.fmh = '1';
      if (isNaN(value)) return;
      span.textContent = value.toFixed(1);
      var text = span.closest('.rating-text');
      text.classList.add('fmh-rating-num');
      var rating = text.parentElement.querySelector('.rating');
      if (rating) {
        rating.classList.add('fmh-rating');
        rating.insertBefore(stars(value), rating.firstChild);
      }
    });
    document.querySelectorAll('.jdgm-preview-badge .jdgm-prev-badge[data-average-rating]').forEach(function (badge) {
      var widget = badge.closest('.jdgm-preview-badge');
      if (widget && SKIP_PRODUCT_IDS.indexOf(widget.dataset.id) !== -1) return;
      var starsBox = badge.querySelector('.jdgm-prev-badge__stars');
      var value = parseFloat(badge.dataset.averageRating);
      if (!starsBox || isNaN(value) || !(parseInt(badge.dataset.numberOfReviews, 10) > 0)) return;
      if (!starsBox.querySelector('.fmh-stars')) {
        starsBox.classList.add('fmh-jdgm-stars');
        starsBox.appendChild(stars(value));
      }
      if (!(starsBox.nextElementSibling && starsBox.nextElementSibling.classList.contains('fmh-jdgm-num'))) {
        var num = document.createElement('span');
        num.className = 'fmh-jdgm-num';
        num.setAttribute('aria-hidden', 'true');
        num.textContent = value.toFixed(1);
        var count = document.createElement('span');
        count.className = 'fmh-jdgm-count';
        count.setAttribute('aria-hidden', 'true');
        count.textContent = '(' + parseInt(badge.dataset.numberOfReviews, 10) + ')';
        starsBox.insertAdjacentElement('afterend', num);
        num.insertAdjacentElement('afterend', count);
      }
    });
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fmhRatings(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fmhRatings);
  else fmhRatings();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
